const subgroups = [
  {
    icon: 'ri-run-line',
    name: 'Mommy Muscle Up',
    tagline: 'Fitness, strength, and showing up for yourself',
    image: 'https://public.readdy.ai/ai/img_res/3ca5100784d53d83eabfb78363dcf9bc.jpg',
    color: 'bg-orange-50 border-orange-100',
    badge: 'bg-orange-100 text-orange-700',
    iconColor: 'text-orange-500',
  },
  {
    icon: 'ri-book-open-line',
    name: 'Books to Make You Blush',
    tagline: 'A book club with a little spice and a lot of laughs',
    image: 'https://readdy.ai/api/search-image?query=four%20young%20women%20ages%2028%20to%2038%20sitting%20in%20a%20cozy%20living%20room%20one%20Black%20woman%20one%20Asian%20woman%20one%20Latina%20woman%20one%20white%20woman%20holding%20wine%20glasses%20and%20books%20laughing%20loudly%20candid%20book%20club%20night%20authentic%20warm%20interior%20lighting%20real%20friendship%20lifestyle%20photography&width=600&height=400&seq=bookclub_multirace_v8&orientation=landscape',
    color: 'bg-rose-50 border-rose-100',
    badge: 'bg-rose-100 text-rose-600',
    iconColor: 'text-rose-500',
  },
  {
    icon: 'ri-sun-cloudy-line',
    name: 'Playdates & Littles',
    tagline: 'Casual meetups for moms and kids',
    image: 'https://readdy.ai/api/search-image?query=three%20moms%20at%20a%20sunny%20Georgia%20playground%20one%20Black%20mom%20one%20Asian%20mom%20one%20white%20mom%20in%20their%20late%2020s%20watching%20diverse%20toddlers%20play%20on%20equipment%20casual%20clothes%20relaxed%20smiling%20candid%20real%20life%20photography%20warm%20afternoon%20sunlight%20suburban%20park%20authentic%20community&width=600&height=400&seq=playdate_multirace_v8&orientation=landscape',
    color: 'bg-sky-50 border-sky-100',
    badge: 'bg-sky-100 text-sky-700',
    iconColor: 'text-sky-500',
  },
  {
    icon: 'ri-cocktail-line',
    name: "Moms Night Out",
    tagline: 'Because you deserve time that\'s just for you',
    image: 'https://readdy.ai/api/search-image?query=four%20young%20women%20moms%20night%20out%20one%20Black%20woman%20one%20Latina%20woman%20one%20Asian%20woman%20one%20white%20woman%20ages%2028%20to%2036%20dressed%20up%20at%20a%20restaurant%20table%20raising%20glasses%20laughing%20celebrating%20candid%20real%20lifestyle%20photography%20warm%20cozy%20restaurant%20ambient%20lighting%20genuine%20joy&width=600&height=400&seq=nightout_multirace_v8&orientation=landscape',
    color: 'bg-purple-50 border-purple-100',
    badge: 'bg-purple-100 text-purple-700',
    iconColor: 'text-purple-500',
  },
];

export default function FindYourPeople() {
  return (
    <section className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-20">
        <div className="text-center mb-16">
          <span className="text-xs font-bold tracking-widest uppercase text-pink-500 mb-4 block">
            Subgroups
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-4">
            Find Your People
          </h2>
          <p className="text-gray-500 text-base max-w-md mx-auto">
            Different seasons. Different interests. Same community.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {subgroups.map((group) => (
            <div
              key={group.name}
              className={`rounded-2xl border overflow-hidden flex flex-col cursor-pointer hover:shadow-md transition-all ${group.color}`}
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={group.image}
                  alt={group.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-black/20" />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold mb-3 self-start ${group.badge}`}>
                  <i className={`${group.icon} text-xs`}></i>
                  {group.name}
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {group.tagline}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
